import { DefaultChatTransport } from "ai";
import { getMessagesApiUrl } from "@/shared/config";
import { authService } from "@/features/auth/services/authService";

/**
 * Custom transport for POST /messages endpoint.
 * Sends: { "chatId": "...", "message": "text" }
 * Server stores messages and maintains context.
 */
export function createChatTransport() {
  return new DefaultChatTransport({
    api: getMessagesApiUrl(),
    credentials: "include",
    headers: async () => {
      const token = await authService.getAccessToken();
      return { authorization: `Bearer ${token}` };
    },
    prepareSendMessagesRequest: async ({ id, messages, headers, credentials, api }) => {
      // Get the last user message (the new one being sent)
      const lastMessage = messages[messages.length - 1];
      if (!lastMessage || lastMessage.role !== "user") {
        throw new Error("Expected user message");
      }

      // Extract text from the message parts
      const textPart = lastMessage.parts.find((p) => p.type === "text");
      if (!textPart || textPart.type !== "text") {
        throw new Error("Expected text part in message");
      }

      return {
        body: { chatId: id, message: textPart.text },
        headers,
        credentials,
        api,
      };
    },
  });
}
